import { Grammar } from './grammar';
import type { TranslationLabels } from '../types/labels.type';
import type { Formatter } from './utils.type';

export interface GenericFormatterConfig {
    noUnits?: boolean;
    labels?: TranslationLabels.Labels;
    step?: number;
}

export enum FormatterType {
    String = 'string',
    Years = 'years',
    Months = 'months',
}

/**
 * @memberof Formatter
 * @function
 * @param {string|number} value
 * @param {GenericFormatterConfig} [config]
 * @returns {string}
 */
export const formatYearsValue: Formatter<number, string> = (
    value: string | number,
    config: GenericFormatterConfig = {}
): string => {
    // TODO GUI-3372 resolve TranslationLabels.Labels assertion.
    return String(
        `${value} ` +
            `${
                !config.noUnits
                    ? ((config.labels?.year as TranslationLabels.Labels)[
                          Grammar.quantify(Number(value))
                      ] as string)
                    : ''
            }`
    ).trim();
};

/**
 * @memberof Formatter
 * @function
 * @param {string|number} value
 * @param {GenericFormatterConfig} [config]
 * @returns {string}
 */
export const formatMonthsValue: Formatter<number, string> = (
    value: string | number,
    config: GenericFormatterConfig = {}
): string => {
    return String(
        `${value} ` +
            `${
                !config.noUnits
                    ? ((config.labels?.month as TranslationLabels.Labels)[
                          Grammar.quantify(Number(value))
                      ] as string)
                    : ''
            }`
    ).trim();
};

/**
 * Used to format value depends on the step in ui-slider and ui-stepper.
 * @memberof Formatter
 * @function
 * @param {string|number} value
 * @param {GenericFormatterConfig} [config]
 * @returns {number}
 */
export const formatStep: Formatter<number | string, number> = (
    value: string | number,
    config: GenericFormatterConfig = {}
): number => {
    const rightPart = String(config.step).split('.')[1];
    const factor = Math.pow(10, rightPart ? rightPart.length : 0);
    return Math.round(Number(value) * factor) / factor;
};

/**
 * @memberof SharedComponents
 * @class Formatter
 * @alias formatters
 */

/**
 * @typedef {("string" | "years" | "months")} FormatterType
 */
/**
 * @typedef {object} GenericFormatterConfig
 * @property {boolean} [noUnits] - do not add units to output
 * @property {TranslationLabels.Labels} [labels] - labels for units like (year, month, etc.)
 * @property {number} [step]
 * }
 */
